import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "app-shell" }
const _hoisted_2 = { class: "hero" }
const _hoisted_3 = { class: "hero__title" }
const _hoisted_4 = { class: "hero__meta" }
const _hoisted_5 = { class: "layout" }
const _hoisted_6 = { class: "column column--left" }
const _hoisted_7 = { class: "panel" }
const _hoisted_8 = {
  key: 0,
  class: "alert",
  role: "alert"
}
const _hoisted_9 = { class: "panel panel--toolbar" }
const _hoisted_10 = { class: "panel" }
const _hoisted_11 = { class: "column column--right" }
const _hoisted_12 = { class: "panel" }
const _hoisted_13 = { class: "panel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Greeting = _resolveComponent("Greeting")!
  const _component_TextEditor = _resolveComponent("TextEditor")!
  const _component_ToolBar = _resolveComponent("ToolBar")!
  const _component_ResultsTable = _resolveComponent("ResultsTable")!
  const _component_EmoteControls = _resolveComponent("EmoteControls")!
  const _component_SearchBar = _resolveComponent("SearchBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("h1", null, "Chatbreaker", -1)),
        _createVNode(_component_Greeting, { class: "hero__greeting" })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", null, "Zeichen: " + _toDisplayString(_ctx.chatContent.length), 1)
      ])
    ]),
    _createElementVNode("main", _hoisted_5, [
      _createElementVNode("section", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "panel__header" }, [
            _createElementVNode("h2", null, "Typing your text")
          ], -1)),
          _createVNode(_component_TextEditor, {
            modelValue: _ctx.chatContent,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.chatContent) = $event)),
            ref: "textEditorRef",
            onStackChanged: _ctx.handleStackChange,
            onKeyup: _ctx.scheduleUpdate
          }, null, 8, ["modelValue", "onStackChanged", "onKeyup"]),
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_ToolBar, {
            selected: _ctx.selected,
            "onUpdate:selected": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selected) = $event)),
            maxWordLength: _ctx.charLimitInput,
            "onUpdate:maxWordLength": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.charLimitInput) = $event)),
            totalCharacter: _ctx.chatContent.length,
            "on-undo": _ctx.handleUndo,
            "on-redo": _ctx.handleRedo,
            "on-clear": _ctx.handleClear,
            "undo-disabled": _ctx.currentUndoLength === 0,
            "redo-disabled": _ctx.currentRedoLength === 0
          }, null, 8, ["selected", "maxWordLength", "totalCharacter", "on-undo", "on-redo", "on-clear", "undo-disabled", "redo-disabled"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "panel__header" }, [
            _createElementVNode("h2", null, "Your split text")
          ], -1)),
          _createVNode(_component_ResultsTable, { singleMessages: _ctx.singleMessages }, null, 8, ["singleMessages"])
        ])
      ]),
      _createElementVNode("section", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "panel__header" }, [
            _createElementVNode("h2", null, "Adding emotes")
          ], -1)),
          _createVNode(_component_EmoteControls, { insertTextAtCursor: _ctx.insertTextAtCursor }, null, 8, ["insertTextAtCursor"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "panel__header panel__header--inline" }, [
            _createElementVNode("h2", null, "Adding chatlinks"),
            _createElementVNode("div", { class: "tag-group" }, [
              _createElementVNode("span", { class: "tag" }, "ger"),
              _createElementVNode("span", { class: "tag" }, "eng")
            ])
          ], -1)),
          _createVNode(_component_SearchBar, { insertTextAtCursor: _ctx.insertTextAtCursor }, null, 8, ["insertTextAtCursor"])
        ])
      ])
    ])
  ]))
}